import script from "./ReportsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsList.vue?vue&type=script&setup=true&lang=js"

import "./ReportsList.vue?vue&type=style&index=0&id=360802b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360802b2"]])

export default __exports__